import { render } from "./StaffDetailOps.vue?vue&type=template&id=65ae03e0&scoped=true"
import script from "./StaffDetailOps.vue?vue&type=script&lang=js"
export * from "./StaffDetailOps.vue?vue&type=script&lang=js"

import "./StaffDetailOps.vue?vue&type=style&index=0&id=65ae03e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ae03e0"]])

export default __exports__